export type ExplorerContextFileRemovalHandlers = {
  handleRemoveFile: (file: File) => Promise<void> | void
  handleRemoveIndexedFile: (fileName: string) => Promise<void> | void
}

export async function removeExplorerContextFile(
  file: File | string,
  { handleRemoveFile, handleRemoveIndexedFile }: ExplorerContextFileRemovalHandlers
) {
  if (typeof file === "string") {
    await handleRemoveIndexedFile(file)
    return
  }

  await handleRemoveFile(file)
}
